import { render, staticRenderFns } from "./CampaignBody.vue?vue&type=template&id=2a889c88&"
import script from "./CampaignBody.vue?vue&type=script&lang=js&"
export * from "./CampaignBody.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports